import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { environment, braspag } from './../../../../../environments/environment';

import { ContaService } from '../../../../shared/services/conta/conta.service';
import { TokenService } from '../../../../shared/services/token/token.service';
import { VendaService } from '../../../../shared/services/venda/venda.service';
import { CartaoService } from '../../../../shared/services/cartao/cartao.service';

import { sendEvent } from '../../../../../assets/analytics/script';

import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/forkJoin';

import * as moment from 'moment';
import * as md5 from 'blueimp-md5';
import { CobrancaService } from '../../../../shared/services/cobranca/cobranca.service';

import { Title } from '@angular/platform-browser';

import { ClienteService } from '../../../../shared/services/cliente/cliente.service';
import { IpService } from '../../../../shared/services/ip/ip.service';
import { CheckoutHelper } from '../../../../shared/helpers/checkout/checkout.helper';
import { SituacaoContaEnum } from '../../../../shared/enums/SituacaoConta.enum';
import { LinkShortenerService } from '../../../../shared/services/link-shortener/link-shortener.service';


declare var $: any;
declare function unescape(s: string): string;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit, OnDestroy {
  public token: any = null;
  public sales: any[] = [];
  public cards: any = null;
  public client: any = null;
  public _client: any = null;
  public account: any = null;
  public cobrancas: any = [];
  public profilePicture: any = null;

  public msgBlock = '';

  public backUrl = '';
  public parcelas: any;

  public saleId = '';
  public tokenId = '';
  public accountId = '';
  public transactionId = '';

  public ipv4 = '';

  public providerIdentifier = '';

  public msgError = '';
  public msgSuccess = '';
  public returnedCode;

  public error = false;
  public success = false;

  public transaction: any = null;

  public cvvForm = false;
  public creditCardsList = false;
  public newCreditCardForm = false;
  public clientData = false;

  public showTable = false;
  public showModal = false;
  public transactionInfo = false;

  public isMenuCreditCardOpen = false;

  public scheduledTransations = true;
  public validationResultError: string = null;

  public successReturnCodesProduction: string[] = ['0', '00', '000', '0000'];
  public successReturnCodesSandbox: string[] = ['4', '6', '0', '00', '000', '0000', '174'];

  public textRemoveCreditCard = '';
  public selectedCreditCard = false;
  public errorRemoveCreditCard = '';
  public modalRemoveCreditCard = false;
  public cartaoRemovido = false;

  public accountNotAllowed = false;

  public cartaoInvalido = false;
  public bandeiraInvalida = false;

  public titles: string[] = ['Pagamento', 'Editar', 'Dados da cobrança'];

  public mostrarBandeiras = false;

  public shortLink = 'Carregando...';
  public copyText = 'Copiar';

  bloqueio = false;

  public valorTotalVendas = 0;
  public valorParcelado = 0;

  public brands: any = [
    { name: 'Visa', className: 'visa', allowSelect: true },
    { name: 'Master', className: 'master', allowSelect: true },
    { name: 'Elo', className: 'elo', allowSelect: true },
    { name: 'JCB', className: 'jcb', allowSelect: false },
    { name: 'Amex', className: 'amex', allowSelect: true },
    { name: 'Aura', className: 'aura', allowSelect: false },
    { name: 'Diners', className: 'diners', allowSelect: true },
    { name: 'Discover', className: 'discover', allowSelect: false },
    { name: 'Hipercard', className: 'hipercard', allowSelect: true }
  ];

  public card: any = {
    cartaoId: null,
    token: null,
    numeroCartao: null,
    bandeiraCartao: null,
    validadeMesCartao: null,
    validadeAnoCartao: null,
    nomeTitularCartao: null,
    codigoSegurancaCartao: null,
  };

  constructor(
    private title: Title,
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private vendaService: VendaService,
    private contaService: ContaService,
    private cartaoService: CartaoService,
    private clienteService: ClienteService,
    private cobrancaService: CobrancaService,
    private ipService: IpService,
    private linkShortener: LinkShortenerService,
    private _clipboardService: ClipboardService
  ) { }

  ngOnInit() {
    this.reset();

    this.setTitle();
    this.getParams();

    this.clickMenuListener();
  }

  ngOnDestroy() {
    const scripts: any = document.getElementsByClassName('script-cybersource');
    const iframes: any = document.getElementsByClassName('iframe-cybersource');

    for (let i = 0; i < scripts.length; i++) {
      if (scripts[0]) { scripts[0].remove(); }
    }

    for (let i = 0; i < iframes.length; i++) {
      if (iframes[0]) { iframes[0].remove(); }
    }
  }

  // https://braspag.github.io//manual/antifraude#cybersource
  setCyberSource() {
    this.providerIdentifier = this.tokenId ? this.tokenId : this.saleId;
    this.providerIdentifier = md5(this.providerIdentifier + moment().toISOString() + new Date().getTime());

    // Set head script
    const s = document.createElement('script');

    s.classList.add('script-cybersource');
    s.type = 'text/javascript';
    s.src = 'https://h.online-metrix.net/fp/tags.js?org_id=' +
            braspag.providerOrgId +  '&session_id=' + braspag.providerMerchantId + this.providerIdentifier;

    document.getElementsByTagName('head')[0].appendChild(s);

    // Set iframe
    const ns = document.createElement('noscript');
    const iframe = document.createElement('iframe');

    iframe.classList.add('iframe-cybersource');
    iframe.classList.add('cybersource-iframe');
    iframe.src = 'https://h.online-metrix.net/fp/tags.js?org_id=' +
                 braspag.providerOrgId +  '&session_id=' + braspag.providerMerchantId + this.providerIdentifier;

    ns.appendChild(iframe);

    document.getElementsByTagName('body')[0].appendChild(ns);
  }

  reset() {
    this.sales = [];
    this.token = null;
    this.cards = null;
    this.client = null;
    this.account = null;
    this.cobrancas = [];
    this.msgBlock = '';
    this.backUrl = '';
    this.cvvForm = false;
    this.saleId = '';
    this.tokenId = '';
    this.accountId = '';
    this.transactionId = '';
    this.msgError = '';
    this.msgSuccess = '';
    this.error = false;
    this.success = false;
    this.transaction = null;
    this.creditCardsList = false;
    this.newCreditCardForm = false;
    this.showTable = false;
    this.showModal = false;
    this.transactionInfo = false;
    this.isMenuCreditCardOpen = false;
    this.scheduledTransations = true;
    this.validationResultError = null;

    this.card = {
      cartaoId: null,
      token: '',
      numeroCartao: '',
      bandeiraCartao: '',
      validadeMesCartao: '',
      validadeAnoCartao: '',
      nomeTitularCartao: '',
      codigoSegurancaCartao: '',
    };
  }

  setTitle() {
    this.title.setTitle('Pague.lá | Checkout');
  }

  getParams() {
    this.route.queryParams.subscribe((data) => {
      // Get url to redirect after process ends
      if (this.getURLParameters('backUrl')) {
        this.backUrl = this.getURLParameters('backUrl');
      }
      if (this.getURLParameters('pc')) {
        this.parcelas = JSON.parse(atob(this.getURLParameters('pc'))).parcelas;
      }

      // Invalid parameters
      if (
        JSON.stringify(data) === '{}' ||
        (data && data.tokenId && data.vendaId && data.transacaoId) ||
        (data && !data.tokenId && !data.vendaId && !data.transacaoId)
      ) {
        this.router.navigate(['checkout/404']);
        return;
      }

      // Go to token
      if (data && data.tokenId) {
        this.tokenId = data.tokenId;
        this.getToken();
        return;
      }

      // Go to sale edit
      if (data && data.vendaId) {
        this.saleId = data.vendaId;
        this.getSale();
        return;
      }

      // Go to transaction info
      if (data && data.transacaoId) {
        this.transactionId = data.transacaoId;
        return;
      }
    });

    this.linkShortener.criarLinkEncurtado(window.location.href).subscribe((data) => {

      this.shortLink = `https://link.pague.la/${data}`;
    });
  }

  getIpv4() {
    this.ipService.getIp().subscribe((data: any) => {
      this.ipv4 = data.ip;
    });
  }

  getURLParameters(paramName) {
    const sURL = window.document.URL.toString();
    if (sURL.indexOf('?') > 0) {
      const arrParams = sURL.split('?');
      const arrURLParams = arrParams[1].split('&');
      const arrParamNames = new Array(arrURLParams.length);
      const arrParamValues = new Array(arrURLParams.length);

      let i = 0;
      for (i = 0; i < arrURLParams.length; i++) {
        const sParam =  arrURLParams[i].split('=');
        arrParamNames[i] = sParam[0];
        if (sParam[1] !== '') {
          arrParamValues[i] = unescape(sParam[1]);
        } else {
          arrParamValues[i] = null;
        }
      }

      for (i = 0; i < arrURLParams.length; i++) {
        if (arrParamNames[i] === paramName) {
          return arrParamValues[i];
        }
      }
      return null;
    }
  }

  getToken() {
    this.tokenService.obterToken(this.tokenId).subscribe((data: any) => {
      this.getIpv4();
      this.setCyberSource();

      // Token does not pass twice
      if (
        data
        && data.Situacao
        && data.Situacao === 'Processado'
        && environment.production
      ) {
        this.openModal('Esta transação expirou');
      } else {
        this.closeModal();
      }

      this.validationResultError = data &&
                                   data.Validacao &&
                                   data.Validacao.Erros &&
                                   data.Validacao.Erros.length > 0 ?
                                   data.Validacao.Erros[0] :
                                   null;

      this.getAccount(data.ContaId);

      this.token = data;
      this.sales = this.sortSales(data.Vendas);
      this.accountId = data.ContaId;
      this.client = data.Vendas[0].Cliente;
      this._client = Object.assign({}, this.client);
      this.cards = data.Vendas[0].Cliente.Cartoes;

      this.valorTotalVendas = this.calcularValoresParcelamento(this.sales).valorTotal;
      this.valorParcelado = this.calcularValoresParcelamento(this.sales).valorDividido;

      if (this.validationResultError) { return; }

      if (this.cards && this.cards.length > 0) {
        const card = this.cards.find((c) => c.CartaoId === this.sales[0].CartaoId);

        if (!card) {
          this.card.cartaoId = this.cards[0].CartaoId;
          this.card.numeroCartao = this.cards[0].Numero;
          this.card.bandeiraCartao = this.cards[0].Bandeira;
          this.card.token = this.cards[0].Token;
          this.card.nomeTitularCartao = this.cards[0].NomeComprador;

          this.card.validadeMesCartao = this.cards[0].DataValidade.split('/')[0];
          this.card.validadeAnoCartao = this.cards[0].DataValidade.split('/')[1].slice(2, 4);
        } else {
          this.card.cartaoId = card.CartaoId;
          this.card.numeroCartao = card.Numero;
          this.card.bandeiraCartao = card.Bandeira;
          this.card.token = card.Token;
          this.card.nomeTitularCartao = card.NomeComprador;

          this.card.validadeMesCartao = card.DataValidade.split('/')[0];
          this.card.validadeAnoCartao = card.DataValidade.split('/')[1].slice(2, 4);
        }

        this.showCreditCardsList();
      } else {
        this.cleanForm();
        this.showNewCreditCardForm();
      }
    }, (err) => {
      console.error(err);

      this.router.navigate(['/checkout/404']);
    });
  }

  calcularValoresParcelamento(vendas) {
    let valorTotal = 0;
    vendas.forEach((venda) => {
      if (venda && venda.Valor && venda.Valor > 0) {
        valorTotal += venda.Valor;
      }
    });

    const valorDividido = valorTotal / this.parcelas;

    return {valorTotal, valorDividido};
  }

  getSale() {
    this.vendaService.obterVenda(this.saleId).subscribe((data: any) => {
      this.getIpv4();
      this.setCyberSource();

      if (
        data
        && data.Situacao
        && data.Situacao === 'Recebido'
        && data.Recorrencia
        && data.Recorrencia.ValorVariaVel === false
        && data.Recorrencia.QuantidadeRecorrencia > 0
        && environment.production
      ) {
        this.openModal('Esta transação expirou');
      }

      this.validationResultError = data &&
                                   data.Validacao &&
                                   data.Validacao.Erros &&
                                   data.Validacao.Erros.length > 0 ?
                                   data.Validacao.Erros[0] :
                                   null;

      this.sales = [];
      this.sales.push(data);
      this.accountId = data.ContaId;
      this.client = data.Cliente;
      this._client = Object.assign({}, this.client);

      if (this.validationResultError) { return; }

      this.getCards();
      this.getAccount(this.accountId);
    }, (err) => {
      console.error(err);
    });
  }

  getCards() {
    this.cartaoService.obterCartoesPorClienteId(this.sales[0].ClienteId).subscribe((data) => {
      this.cards = data;

      if (this.cards && this.cards.length > 0 && this.sales && this.sales.length > 0) {
        this.showCreditCardsList();

        const card = this.cards.find((c) => c.CartaoId === this.sales[0].CartaoId);

        if (!card) {
          this.card.token = this.cards[0].Token;
          this.card.cartaoId = this.cards[0].CartaoId;
          this.card.numeroCartao = this.cards[0].Numero;
          this.card.bandeiraCartao = this.cards[0].Bandeira;
          this.card.nomeTitularCartao = this.cards[0].NomeComprador;

          this.card.validadeMesCartao = this.cards[0].DataValidade.split('/')[0];
          this.card.validadeAnoCartao = this.cards[0].DataValidade.split('/')[1].slice(2, 4);
        } else {
          this.card.cartaoId = card.CartaoId;
          this.card.numeroCartao = card.Numero;
          this.card.bandeiraCartao = card.Bandeira;
          this.card.token = card.Token;
          this.card.nomeTitularCartao = card.NomeComprador;

          this.card.validadeMesCartao = card.DataValidade.split('/')[0];
          this.card.validadeAnoCartao = card.DataValidade.split('/')[1].slice(2, 4);
        }
      } else {
        this.showNewCreditCardForm();
      }
    }, (err) => {
      console.error(err);
    });
  }

  getAccount(contaId) {
    this.contaService.obterConta(contaId).subscribe((data: any) => {
      this.account = data;

      if (this.account && this.account.Objetos && this.account.Objetos.length > 0) {
        this.account.Objetos.forEach((objeto) => {
          if (objeto.TipoObjeto === 3) {
            this.profilePicture = 'https://' + objeto.CaminhoObjeto;
          }
        });
      }

      if (this.account && this.account.Situacao == SituacaoContaEnum.Bloqueada) {
        this.bloqueio = true;
      }

      if (environment.production && data.TipoCadastro === 'PagueLa') {
        this.checkAccount();
      }
    }, (err) => {
      console.error(err);
    });
  }

  updateClient() {
    this.enableLoading();

    const arrDate = this.client.DataNascimento.split('/');

    const day = arrDate[0];
    const month = arrDate[1];
    const year = arrDate[2];

    if (day && month && year) {
      this.client.DataNascimento = new Date(year, month - 1, day);
    } else {
      this.client.DataNascimento = null;
    }

    this.clienteService.atualizarCliente(this.client).subscribe(() => {
      this.tokenId ? this.process() : this.update();
    }, (err) => {
      sendEvent('checkout', 'atualizar-cliente-erro');

      this.disableLoading();
      console.error(err);

      this.error = true;
      this.success = false;
      this.msgSuccess = '';
      this.clientData = false;
      this.creditCardsList = false;
      this.newCreditCardForm = false;
      this.msgError = 'Não foi possível efetuar a operação';
    });
  }

  sortSales(sales) {
    let parceladas = sales.filter((sale) => sale.Parcelas !== null);
    let recorrentes = sales.filter((sale) => sale.Recorrencia);

    recorrentes = recorrentes.sort(function (a, b) {
      if (
        b.Recorrencia &&
        !b.Recorrencia.QuantidadeRecorrencia
      ) {
        return 1;
      }

      if (
        a.Recorrencia &&
        a.Recorrencia.QuantidadeRecorrencia &&
        b.Recorrencia &&
        b.Recorrencia.QuantidadeRecorrencia &&
        a.Recorrencia.QuantidadeRecorrencia > b.Recorrencia.QuantidadeRecorrencia
      ) {
        return 1;
      }

      if (
        a.Recorrencia &&
        a.Recorrencia.QuantidadeRecorrencia &&
        b.Recorrencia &&
        b.Recorrencia.QuantidadeRecorrencia &&
        a.Recorrencia.QuantidadeRecorrencia < b.Recorrencia.QuantidadeRecorrencia
      ) { return -1; }

      return 0;
    });

    parceladas = parceladas.sort(function (a, b) {
      if (a.Parcelas > b.Parcelas) { return 1; }
      if (a.Parcelas < b.Parcelas) { return -1; }
      return 0;
    });

    return sales;
  }

  checkAccount() {
    let isIncomplete = false;

    // Dados PF
    if (
      (this.account.TipoConta && this.account.TipoConta === 'Fisica') &&
      (!this.account.CpfCnpj || this.account.CpfCnpj.length === 0 ||
      !this.account.Nome || this.account.Nome.length === 0 ||
      !this.account.Sobrenome || this.account.Sobrenome.length === 0)
    ) {
      isIncomplete = true;
    }

    // Dados PJ
    if (
      (this.account.TipoConta && this.account.TipoConta === 'Juridica') &&
      (!this.account.CpfCnpj || this.account.CpfCnpj.length === 0 ||
      !this.account.RazaoSocial || this.account.RazaoSocial.length === 0 ||
      !this.account.Fantasia || this.account.Fantasia.length === 0 ||
      !this.account.Nome || this.account.Nome.length === 0)
    ) {
      isIncomplete = true;
    }

    // Endereço
    if (
      !this.account.Enderecos || this.account.Enderecos.length === 0 ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Cep || this.account.Enderecos[0].Cep.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Logradouro || this.account.Enderecos[0].Logradouro.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Numero || this.account.Enderecos[0].Numero.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Bairro || this.account.Enderecos[0].Bairro.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Cidade || this.account.Enderecos[0].Cidade.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Estado || this.account.Enderecos[0].Estado.length === 0)
    ) {
      isIncomplete = true;
    }

    // Informações Bancárias
    if (
      !this.account.InformacoesBancarias || this.account.InformacoesBancarias.length === 0 ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].Banco || this.account.InformacoesBancarias[0].Banco.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].Agencia || this.account.InformacoesBancarias[0].Agencia.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].NumeroConta || this.account.InformacoesBancarias[0].NumeroConta.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].ContaDigito || this.account.InformacoesBancarias[0].ContaDigito.length === 0)
    ) {
      isIncomplete = true;
    }

    if (this.account && this.account.Situacao != SituacaoContaEnum.Ativa) {
      this.openModal('O seu cadastro está pendente de aprovação.');
      return;
    }

    if (isIncomplete === true) {
      this.openModal('Os dados da sua conta estão incompletos. Faça o login e preencha os dados que estão faltando.');
      return;
    }
  }

  showCreditCardsList() {
    this.error = false;
    this.msgError = '';
    this.success = false;
    this.cvvForm = false;
    this.msgSuccess = '';
    this.clientData = false;
    this.creditCardsList = true;
    this.newCreditCardForm = false;
  }

  showNewCreditCardForm() {
    this.error = false;
    this.msgError = '';
    this.success = false;
    this.cvvForm = false;
    this.msgSuccess = '';
    this.clientData = false;
    this.card.cartaoId = null,
    this.creditCardsList = false;
    this.newCreditCardForm = true;
  }

  showClientData() {
    this.error = false;
    this.msgError = '';
    this.success = false;
    this.cvvForm = false;
    this.msgSuccess = '';
    this.clientData = true;
    this.creditCardsList = false;
    this.newCreditCardForm = false;
  }

  showCvvForm() {
    this.error = false;
    this.msgError = '';
    this.success = false;
    this.msgSuccess = '';
    this.cvvForm = true;
    this.creditCardsList = false;
    this.newCreditCardForm = false;

    this.card.numeroCartao = 'XXXX XXXX XXXX ' + this.card.numeroCartao;
  }

  actionNewCreditCard() {
    if (this.checkAccountId()) {
      return;
    }

    sendEvent('checkout', 'novo_cartao');

    this.cleanForm();
    this.showNewCreditCardForm();
  }

  selectCreditCard(e, cartao) {
    if (this.checkAccountId()) {
      return;
    }

    sendEvent('checkout', 'selecionar_cartao');

    const cards = this.elRef.nativeElement.querySelectorAll('.cartao');

    cards.forEach((c) => {
      c.classList.add('disabled');
    });

    const card = this.cards.find((c: any) => c === cartao);

    if (card) {
      this.card.cartaoId = card.CartaoId;
      this.card.token = card.Token;
      this.card.numeroCartao = card.Numero;
      this.card.bandeiraCartao = card.Bandeira;
      this.card.nomeTitularCartao = card.NomeComprador;

      this.card.validadeMesCartao = card.DataValidade.split('/')[0];
      this.card.validadeAnoCartao = card.DataValidade.split('/')[1].slice(2, 4);

      e.currentTarget.classList.remove('disabled');
    }
  }

  isRemoveWordCorrect() {
    return this.textRemoveCreditCard.toLocaleLowerCase() === 'excluir' ? true : false;
  }

  showModalRemoveCreditCard(e: any, creditCard: any) {
    this.cartaoRemovido = false;
    this.textRemoveCreditCard = '';
    this.modalRemoveCreditCard = true;
    this.selectedCreditCard = creditCard;

    this.toggleMenu(e.target.parentNode);
  }

  closeModalRemoveCreditCard() {
    this.selectedCreditCard = null;
    this.modalRemoveCreditCard = false;
  }

  removeCard(e: any) {
    if (!this.isRemoveWordCorrect()) {
      const textarea = document.getElementById('textarea-excluir');
      textarea.classList.add('color-red');
      this.errorRemoveCreditCard = 'Você deve digitar corretamente a palavra acima.';

      return;
    } else {
      const textarea = document.getElementById('textarea-excluir');
      textarea.classList.remove('color-red');
      this.errorRemoveCreditCard = '';
    }

    const cartao: any = this.selectedCreditCard;

    this.adicionarLoadingExcluir();

    this.cartaoService.removerCartao(cartao.CartaoId).subscribe(() => {
      sendEvent('checkout', 'remover_cartao_sucesso');
      this.reload();
      this.cartaoRemovido = true;
    }, (err) => {
      sendEvent('checkout', 'remover_cartao_erro');

      const textarea = document.getElementById('textarea-excluir');
      textarea.classList.add('color-red');

      this.errorRemoveCreditCard = err &&
                    err.error &&
                    err.error.ModelState &&
                    err.error.ModelState &&
                    err.error.ModelState.Erros &&
                    err.error.ModelState.Erros.length > 0 ?
                    err.error.ModelState.Erros[0] :
                    'Não foi possível remover o cartão';

      this.removerLoadingExcluir();

      console.error(err);
    });
  }

  adicionarLoadingExcluir() {
    const btn = document.getElementById('btn-remover');
    btn.classList.add('loading');
  }

  removerLoadingExcluir() {
    const btn = document.getElementById('btn-remover');
    btn.classList.remove('loading');
  }

  nextInput(e) {
    const elId = e.target.id;
    const elValue = e.target.value.replace(/ /g, '');

    if (!this.card.token && !this.newCreditCardForm) {
      return;
    }

    e.target.parentNode.classList.remove('has-error');
    e.target.parentNode.parentNode.classList.remove('has-error');

    if (elId === 'cartao') {
      this.cartaoInvalido = false;
    }

    if (
      elId === 'cartao' &&
      elValue.length === 16
    ) {
      document.getElementById('validademes').focus(); return;
    }

    if (
      elId === 'codseguranca' &&
      elValue.length === 3 &&
      this.card &&
      this.card.bandeiraCartao !== 'Amex'
    ) {
      document.getElementById('nometitular').focus(); return;
    }

    if (
      elId === 'codseguranca' &&
      elValue.length === 4 && this.card &&
      this.card.bandeiraCartao === 'Amex'
    ) {
      document.getElementById('nometitular').focus(); return;
    }

    if (elId === 'validademes') {
      const validadeMes: any = document.getElementById('validademes');
      const validadeAno: any = document.getElementById('validadeano');

      if (elValue.length === 2) { document.getElementById('validadeano').focus(); }
      if (elValue < '01' || elValue > '12') { e.target.parentNode.classList.add('has-error'); }
      if (!this.isValidDateValid()) {
        if (validadeMes && validadeAno && validadeMes.value && validadeAno.value) {
          validadeMes.parentNode.classList.add('has-error');
          validadeAno.parentNode.classList.add('has-error');
        }
        return;
      }
      if (validadeMes && validadeAno && validadeMes.value && validadeAno.value) {
        validadeMes.parentNode.classList.remove('has-error');
        validadeAno.parentNode.classList.remove('has-error');
      }
      return;
    }

    if (elId === 'validadeano') {
      const validadeMes: any = document.getElementById('validademes');
      const validadeAno: any = document.getElementById('validadeano');

      if (elValue.length === 2) { document.getElementById('codseguranca').focus(); }
      if (elValue < '18' || elValue > '99') { e.target.parentNode.classList.add('has-error'); }
      if (!this.isValidDateValid()) {
        if (validadeMes && validadeAno && validadeMes.value && validadeAno.value) {
          validadeMes.parentNode.classList.add('has-error');
          validadeAno.parentNode.classList.add('has-error');
        }
        return;
      }
      if (validadeMes && validadeAno && validadeMes.value && validadeAno.value) {
        validadeMes.parentNode.classList.remove('has-error');
        validadeAno.parentNode.classList.remove('has-error');
      }
      return;
    }
  }

  hasError() {
    let hasError = false;
    const inputs = this.elRef.nativeElement.querySelectorAll('input');

    for (let i = 0; i < inputs.length; i++) {
      const value = inputs[i].value.replace(/ /g, '');

      if (inputs[i].id === 'cartao' && !value) {
        hasError = true;
        inputs[i].parentNode.parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'cartao' && !this.card.bandeiraCartao) {
        hasError = true;
        this.bandeiraInvalida = true;
      }

      if (inputs[i].id === 'validademes' && (!value || value < '01' || value > '12' || !this.isValidDateValid())) {
        hasError = true;
        inputs[i].parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'validadeano' && (!value || value < '18' || value > '99' || !this.isValidDateValid())) {
        hasError = true;
        inputs[i].parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'codseguranca' && (!value || value.length < 3)) {
        hasError = true;
        inputs[i].parentNode.classList.add('has-error');
      }

      if (inputs[i].id === 'nometitular' && !value) {
        hasError = true;
        inputs[i].parentNode.classList.add('has-error');
      }
    }

    if (hasError) { return true; }
    if (!hasError) { return false; }
  }

  isValidDateValid() {
    if (!this.newCreditCardForm) { return true; }
    if (!this.card.validadeMesCartao || !this.card.validadeAnoCartao) { return false; }

    const todayDate = moment();
    const validDate = moment('20' + this.card.validadeAnoCartao + '-' + this.card.validadeMesCartao + '-' + '01');

    const isValid = validDate.isSameOrAfter(todayDate, 'year') && validDate.isSameOrAfter(todayDate, 'month');

    return isValid;
  }

  isValidForm() {
    let hasOneInvalid = false;
    const form = this.elRef.nativeElement.querySelector('#form-checkout');
    const inputs = this.elRef.nativeElement.querySelectorAll('#form-checkout input');

    if (this.cartaoInvalido) { return false; }

    if (this.hasError()) { return false; }

    if (!form) { return true; }

    inputs.forEach((input) => {
      input.parentNode.classList.remove('has-error');
      input.parentNode.parentNode.classList.remove('has-error');

      if (!input.value || (input.id === 'email' && !this.isValidEmail(this.client.Email))) {
        hasOneInvalid = true;
        input.parentNode.classList.add('has-error');
        input.parentNode.parentNode.classList.add('has-error');
      }
    });

    return hasOneInvalid ? false : true;
  }

  isValidEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  isValidClient() {
    let isValid = true;

    if (
      this.client &&
      (
        !this.client.Cep ||
        !this.client.Nome ||
        !this.client.Email ||
        !this.client.Estado ||
        !this.client.Cidade ||
        !this.client.Bairro ||
        !this.client.CpfCnpj ||
        !this.client.Telefone ||
        !this.client.Logradouro ||
        !this.client.DataNascimento ||
        !this.client.EnderecoNumero
      )
    ) {
      isValid = false;
    }

    return isValid;
  }

  isStone() {
    const adquirente = this.account.Adquirentes.find((ad: any) => ad.Padrao === true );
    if (adquirente && adquirente.Nome && adquirente.Nome.indexOf('Stone') > -1) {
      return true;
    }
    return false;
  }

  isTipoCadastroPagueLa() {
    return this.account && this.account.TipoCadastro === 'PagueLa' ? true : false;
  }

  submit(e: any) {
    if (this.checkAccountId()) {
      return;
    }

    e.preventDefault();

    // Inputs validation
    if (!this.isValidForm() && this.account) {
      this.disableLoading();
      return;
    }

    // Client validation
    if (!this.isValidClient() && this.account.TipoCadastro === 'PagueLa') {
      this.showClientData();
      return;
    }

    if (this.clientData && this.isValidClient() && this.account.TipoCadastro === 'PagueLa') {
      this.updateClient();
      return;
    }

    this.tokenId ? this.process() : this.update();
  }

  process() {
    this.enableLoading();
    console.log(this.parcelas, 'this.parcelas');
    console.log(this.sales[0].Parcelas, 'salesParcela');
    const data = {
      CaixaPreta: this.providerIdentifier,
      Ipv4: this.account && this.account.TipoCadastro === 'PagueLa' ? this.ipv4 : null,
      Valor: null,
      PedidoLojaId: null,
      NumeroParcelas: this.parcelas || this.sales[0].Parcelas || 1,
      TipoMeioPagamento: 'CreditCard',
      MeioPagamento: '',
      CapturarAutomaticamente: true,
      CartaoId: this.card.cartaoId ? this.card.cartaoId : null,
      NumeroCartao: !this.card.cartaoId ? this.card.numeroCartao : null,
      ContaId: this.token && this.token.ContaId ? this.token.ContaId : null,
      NomeComprador: !this.card.cartaoId ? this.card.nomeTitularCartao : null,
      CodigoSegurancaCartao: !this.card.cartaoId ? this.card.codigoSegurancaCartao : null,
      NomeCompradorImpressoCartao: !this.card.cartaoId ? this.card.nomeTitularCartao : null,
      BandeiraCartao: this.card.bandeiraCartao ? this.card.bandeiraCartao : null,
      DataValidadeCartao: !this.card.cartaoId &&
                          this.card.validadeMesCartao &&
                          this.card.validadeAnoCartao ?
                          this.card.validadeMesCartao + '/20' + this.card.validadeAnoCartao : null
    };

    this.tokenService.processarVenda(this.tokenId, data).subscribe((result) => {
      sendEvent('checkout', 'processar_token_sucesso');

      this.disableLoading();
      this.showProcessResult(result);
    }, (err) => {
      sendEvent('checkout', 'processar_token_erro');

      this.disableLoading();
      console.error(err);

      let message = '';

      if (
        err &&
        err.error &&
        err.error.ModelState &&
        err.error.ModelState &&
        err.error.ModelState.Erros &&
        err.error.ModelState.Erros.length > 0
      ) {
        err.error.ModelState.Erros.forEach((erro: any) => {
          message = erro + '<br>';
        });
      } else {
        message = 'Não foi possível efetuar a operação';
      }

      this.error = true;
      this.cvvForm = false;
      this.success = false;
      this.msgSuccess = '';
      this.clientData = false;
      this.creditCardsList = false;
      this.newCreditCardForm = false;
      this.msgError = message;
    });
  }

  update() {
      this.enableLoading();
      this.updateSale();
  }

  updateSale() {
    if (this.sales && this.sales.length > 0) {
      const cartao = {
        ContaId: this.sales[0].ContaId,
        Numero: this.card.numeroCartao,
        ClienteId: this.sales[0].ClienteId,
        NomeComprador: this.card.nomeTitularCartao,
        CartaoId: this.newCreditCardForm ? null : this.card.cartaoId,
        Bandeira: this.card.bandeiraCartao ? this.card.bandeiraCartao : null,
        DataValidade: this.card.validadeMesCartao + '/20' + this.card.validadeAnoCartao
      };

      this.sales[0].Cartao = cartao;
      this.sales[0].Validacao = {};
      this.sales[0].FormaDePagamento = 'Cartao';

      this.sales[0].Situacao = this.sales[0].Situacao === 'Cancelada' ? 'Aberta' : this.sales[0].Situacao;

      delete this.sales[0].Boletos;
      delete this.sales[0].CartaoId;
      delete this.sales[0].Cobrancas;
      delete this.sales[0].Recorrencia;

      this.enableLoading();

      this.sales[0].Ipv4 = this.account.TipoCadastro === 'PagueLa' ? this.ipv4 : '';
      this.sales[0].CaixaPreta = this.providerIdentifier;

      this.vendaService.atualizarVenda(this.sales[0]).subscribe((data) => {
        sendEvent('checkout', 'editar_venda_sucesso');

        this.disableLoading();
        this.showProcessResult(data);
      }, (err) => {
        sendEvent('checkout', 'editar_venda_erro');
        console.error(err);

        let message = '';

        if (
          err &&
          err.error &&
          err.error.ModelState &&
          err.error.ModelState &&
          err.error.ModelState.Erros &&
          err.error.ModelState.Erros.length > 0
        ) {
          err.error.ModelState.Erros.forEach((erro: any) => {
            message = erro + '<br>';
          });
        } else {
          message = 'Não foi possível efetuar a operação';
        }

        this.error = true;
        this.cvvForm = false;
        this.success = false;
        this.msgSuccess = '';
        this.clientData = false;
        this.creditCardsList = false;
        this.newCreditCardForm = false;
        this.msgError = message;

        this.disableLoading();
      });
    }
  }

  showProcessResult(data: any) {
    this.transaction = data;

    this.cvvForm = false;
    this.clientData = false;
    this.creditCardsList = false;
    this.newCreditCardForm = false;

    this.card.codigoSegurancaCartao = null;

    const vendasArr: any = [];
    this.sales.forEach((venda) => {
      if (venda.Recorrencia !== null) {
        vendasArr.push(this.cobrancaService.obterCobrancasPorVendaId(venda.VendaId));
      }
    });

    Observable
      .forkJoin(vendasArr)
      .subscribe((response: any) => {
        this.cobrancas = [];

        response.forEach((c: any) => {
          c.Cobrancas.forEach((cobranca: any) => {
            cobranca.passed = false;

            if (
                !this.isTodayDate(cobranca.DataCobranca) &&
                !this.isPastDate(cobranca.DataCobranca)
              ) {
              this.cobrancas.push(cobranca);
            }
          });
        });

        this.cobrancas = this.sumSameDateValues(this.cobrancas);

        this.cobrancas.sort(function(a, b) {
          const dateA = a.DataCobranca;
          const dateB = b.DataCobranca;
          if (!moment(dateA).isAfter(dateB)) {
            return -1;
          }
          if (moment(dateA).isAfter(dateB)) {
            return 1;
          }
          return 0;
        });

        this.cobrancas.forEach((cobranca) => {
          cobranca.Valor = cobranca.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          cobranca.DataCobranca = moment(cobranca.DataCobranca).format('DD/MM/YYYY');
        });
      }, (err) => {
        console.error(err);
      });

    this.scheduledTransations = true;

    if (this.transaction.MensagemAgendamento) {
      this.error = false;
      this.msgError = '';
      this.returnedCode = '';
      this.success = true;
      this.transactionInfo = false;
      this.msgSuccess = 'Agendamento efetuado com sucesso!';

      return;
    }

    if (this.saleId && this.transaction.Transacao === null) {
      this.error = false;
      this.msgError = '';
      this.returnedCode = '';
      this.success = true;
      this.transactionInfo = false;
      this.msgSuccess = 'A venda foi atualizada com sucesso!';

      return;
    }

    const returnCodes = environment.production ? this.successReturnCodesProduction : this.successReturnCodesSandbox;
    const returnedCode = data &&
                      data.Transacao &&
                      data.Transacao.CodigoRetorno ?
                      'Código de Retorno: ' + data.Transacao.CodigoRetorno :
                      null;
    const msgError = data &&
                     data.Transacao &&
                     data.Transacao.MensagemRetornoAdquirencia ?
                     data.Transacao.MensagemRetornoAdquirencia :
                     'Não foi possível efetuar a operação';

    if (
      this.transaction &&
      this.transaction.Transacao &&
      (
        this.transaction.Transacao.CodigoRetorno === returnCodes[0] ||
        this.transaction.Transacao.CodigoRetorno === returnCodes[1] ||
        this.transaction.Transacao.CodigoRetorno === returnCodes[2] ||
        this.transaction.Transacao.CodigoRetorno === returnCodes[3] ||
        this.transaction.Transacao.CodigoRetorno === returnCodes[4] ||
        this.transaction.Transacao.CodigoRetorno === returnCodes[5] ||
        this.transaction.Transacao.CodigoRetorno === returnCodes[6]
      )
    ) {
      this.error = false;
      this.msgError = '';
      this.returnedCode = '';
      this.success = true;
      this.transactionInfo = true;
      this.msgSuccess = 'Operação Efetuada com sucesso!';
    } else {
      this.error = true;
      this.success = false;
      this.msgSuccess = '';
      this.transactionInfo = true;
      this.msgError = msgError;
      this.returnedCode = returnedCode;
    }
  }

  sumSameDateValues(arr) {
    const arrAux = [];

    arr.forEach((cA, iA) => {
      const obj = {
        Valor: cA.Valor,
        DataCobranca: cA.DataCobranca
      };

      arr.forEach((cB, iB) => {
        if (cA.DataCobranca === cB.DataCobranca && iB > iA && !cB.passed && !cA.passed) {
          cB.passed = true;
          obj.Valor += cB.Valor;
        }
      });

      if (!cA.passed) {
        arrAux.push(obj);
      }
    });

    return arrAux;
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').setAttribute('disabled', 'disabled');
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').removeAttribute('disabled');
  }

  toggleMenu(e) {
    if (this.checkAccountId()) {
      return;
    }

    const element = e.target ? e.target.querySelector('.menu-remove') : e.querySelector('.menu-remove');
    const elements = this.elRef.nativeElement.querySelectorAll('.menu-remove');

    if (!element) { return; }

    if (element.style.display === 'none') {
      elements.forEach((el) => {
        el.style.display = 'none';
      });

      element.style.display = 'block';

      this.isMenuCreditCardOpen = true;
    } else {
      element.style.display = 'none';
    }
  }

  toggleCobrancas(e) {
    e.preventDefault();
    this.showTable = !this.showTable;
  }

  cleanForm() {
    this.card = {
      cartaoId: null,
      numeroCartao: null,
      bandeiraCartao: null,
      validadeMesCartao: null,
      validadeAnoCartao: null,
      nomeTitularCartao: null,
      codigoSegurancaCartao: null,
    };
  }

  actionReload() {
    sendEvent('checkout', 'tentar_novamente');

    this.reload();
  }

  reload() {
    if (this.saleId) {
      this.getSale();
    }

    if (this.tokenId) {
      this.getToken();

      this.resetCard();
      this.transactionInfo = false;
    }
  }

  resetCard() {
    this.card.codigoSegurancaCartao = null;
  }

  getLastDigits(numeroCartao) {
    return numeroCartao.substring(numeroCartao.length - 4, numeroCartao.length);
  }

  getFormatedDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  clickMenuListener() {
    const self = this;
    document.querySelector('body').addEventListener('click', function(e: any) {
      if (e.target.className !== 'menu-remove' && e.target.className !== 'editar-cartao-button') {
        const elements = self.elRef.nativeElement.querySelectorAll('.menu-remove');
        if (elements && elements.length > 0) {
          elements.forEach((el) => {
            if (el.style.display === 'block') {
              el.style.display = 'none';
            }
          });
        }
      }
    });
  }

  getClassBandeiraCartao(brandCreditCard) {
    let className = null;
    this.brands.forEach((brand) => {
      if (brand.name === brandCreditCard) {
        className =  brand.className;
      }
    });
    return className;
  }

  setBrand(e) {
    if (!e.name) {
      this.mostrarBandeiras = true;
      return;
    }

    this.mostrarBandeiras = false;

    if (e.name === 'Amex') {
      $('#cartao').mask('0000 000000 00000');
    } else {
      $('#cartao').mask('0000 0000 0000 0000');
    }

    this.card.bandeiraCartao = e.name;
  }

  isTodayDate(date) {
    return moment(date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY') ? true : false;
  }

  isPastDate(date) {
    const now = moment();
    const then = moment(date);

    const isBefore = then.isBefore(now, 'day');

    return isBefore;
  }

  checkAccountId() {
    if (
      this.token &&
      this.tokenId &&
      this.token.ContaId &&
      this.token.ContaId.toLowerCase() === 'a283b0c0-c45b-4f16-989d-22174080c7d8'
    ) {
      this.accountNotAllowed = true;
      this.openModal('Você ainda não habilitou este serviço.');
      return true;
    }

    return false;
  }

  openModal(msg) {
    this.showModal = true;
    this.msgBlock = msg;
  }

  closeModal() {
    this.showModal = false;
    this.msgBlock = '';
  }

  verifyInputs() {
    if (this.checkAccountId()) {
      return;
    }

    const inputs = this.elRef.nativeElement.querySelectorAll('#form-checkout input');

    inputs.forEach((input) => {
      switch (input.name) {
        case 'cartao':
          input.parentNode.classList.remove('has-error');

          const valido = CheckoutHelper.cartaoValido(this.card.numeroCartao);

          if (!valido && input.value.length) {
            this.mostrarMensagemCartaoInvalido(input);
          }

          break;
        case 'validademes':
          if (
            this.card && this.card.validadeMesCartao &&
            this.card.validadeMesCartao.length === 1 &&
            this.card.validadeMesCartao >= '1' &&
            this.card.validadeMesCartao <= '9'
          ) {
            this.card.validadeMesCartao = '0' + this.card.validadeMesCartao;
            input.parentNode.classList.remove('has-error');
          }

          break;
      }
    });
  }

  mostrarMensagemCartaoInvalido(input: any) {
    this.cartaoInvalido = true;
  }

  actionBack() {
    sendEvent('checkout', 'voltar');

    const card = this.cards.find((c) => c.CartaoId === this.sales[0].CartaoId);

    if (!card) {
      this.card.cartaoId = this.cards[0].CartaoId;
      this.card.numeroCartao = this.cards[0].Numero;
      this.card.bandeiraCartao = this.cards[0].Bandeira;
      this.card.nomeTitularCartao = this.cards[0].NomeComprador;

      this.card.validadeMesCartao = this.cards[0].DataValidade.split('/')[0];
      this.card.validadeAnoCartao = this.cards[0].DataValidade.split('/')[1].slice(2, 4);
    } else {
      this.card.cartaoId = card.CartaoId;
    }

    this.showCreditCardsList();
  }

  actionBackActuar() {
    sendEvent('checkout', 'voltar_ao_actuar');

    window.location.href = this.backUrl;
  }

  isValor() {
    return this.sales && this.sales.length > 0 && this.sales[0].Situacao === 'Aberta';
  }

  selecionarBandeiraCartao(nomeBandeira: string): void {
    this.bandeiraInvalida = false;
    this.card.bandeiraCartao = nomeBandeira;
  }

  bandeiraAtiva(nomeBandeira: string): boolean {
    return nomeBandeira === this.card.bandeiraCartao;
  }

  getUrl(): string {
    if (this.tokenId) {
      return window.location.origin + '/#/checkout?tokenId=' + this.tokenId;
    }

    if (this.saleId) {
      return window.location.origin + '/#/checkout?vendaId=' + this.saleId;
    }

    if (this.transactionId) {
      return window.location.origin + '/#/checkout?transacaoId=' + this.transactionId;
    }

    return window.location.href;
  }

  copiarShortUrl() {
    this._clipboardService.copyFromContent(this.shortLink);
    this.copyText = 'Copiado!';
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/checkout/components/checkout/checkout.component.ts